export const getAgentTourSteps = (t) => [
  {
    selector: '[data-tour-id="navItem"]',
    content: t("agent.walkthrough.navItem"),
    position: 'right',
  },
  {
    selector: '[data-tour-id="nav-cold-calls"]',
    content: t("agent.walkthrough.coldCalls"),
    position: "right",
  },
  {
    selector: '[data-tour-id="nav-follow-up"]',
    content: t("agent.walkthrough.followUp"),
    position: "right",
  },
  {
    selector: '[data-tour-id="nav-meeting"]',
    content: t("agent.walkthrough.meeting"),
    position: "right",
  },
  {
    selector: '[data-tour-id="nav-meeting-recovery"]',
    content: t("agent.walkthrough.recovery"),
    position: "right",
  },
  {
    selector: '[data-tour-id="agent-date-filter"]',
    content: t("admin.walkthrough.date"),
    position: "bottom",
  },
  {
    selector: '[data-tour-id="start-calls-button"]',
    content: t("agent.walkthrough.startCall"),
    position: "top",
  },
  {
    selector: '[data-tour-id="finish-day"]',
    content: t("agent.walkthrough.finish"),
    position: "right",
  },
];
